import { all } from 'typed-redux-saga'
import {
	bgRequestSaga,
	limitRequestSaga,
	limitRequestSocketSaga,
	bgBlackListSaga,
	bgDocumentSaga,
	bgRequestSocketSaga,
	bgLeadSaga,
	clientLimitInfoSaga,
	emailSaga,
} from 'Pages/ibro'
import { trustSaga } from 'Pages/ibro/settings/store/saga'

export function* iBroSaga() {
	yield* all([
		limitRequestSocketSaga(),
		limitRequestSaga(),
		bgRequestSaga(),
		bgBlackListSaga(),
		bgDocumentSaga(),
		bgRequestSocketSaga(),
		bgLeadSaga(),
		clientLimitInfoSaga(),
		trustSaga(),
		emailSaga(),
	])
}
